import { daysBetweenDates } from '@gonfalon/format/daysBetweenDates';
import { parseISO, sub } from 'date-fns';

import type { LegacySubscription } from '../../types';

export function getTrialDaysRemaining(legacySubscription: LegacySubscription) {
  const { trialEndDate } = legacySubscription;
  return daysBetweenDates(parseISO(trialEndDate ?? ''), sub(new Date(), { days: 1 }));
}
